import { createStore } from "vuex";
import { applyTheme, resetTheme } from "@/services/theme";

const storedCompany = (() => {
  try {
    return JSON.parse(localStorage.getItem("currentCompany") || "null");
  } catch {
    localStorage.removeItem("currentCompany");
    return null;
  }
})();

if (storedCompany) applyTheme(storedCompany);

export default createStore({
  state: {
    updateAvailable: false,
    updateApkUrl: "",
    authToken: localStorage.getItem("authToken") || null,
    refreshToken: localStorage.getItem("refreshToken") || null,
    currentUser: (() => {
      try {
        return JSON.parse(localStorage.getItem("currentUser") || "null");
      } catch {
        localStorage.removeItem("currentUser");
        return null;
      }
    })(),
    currentCompany: storedCompany,
    companies: (() => {
      try {
        return JSON.parse(localStorage.getItem("companies") || "[]");
      } catch {
        localStorage.removeItem("companies");
        return [];
      }
    })(),
  },
  getters: {
    isAuthenticated: (state) => !!state.authToken,
    currentUser: (state) => state.currentUser,
    currentCompany: (state) => state.currentCompany,
    currentRole: (state) => state.currentCompany?.role || null,
    companies: (state) => state.companies,
    hasCompanySelected: (state) => !!state.currentCompany,
    isSuperAdmin: (state) => state.currentUser?.super_admin === true,
  },
  mutations: {
    SET_UPDATE_AVAILABLE(state, { apkUrl }) {
      state.updateAvailable = true;
      state.updateApkUrl = apkUrl;
    },
    SET_AUTH(state, { token, refreshToken, user, companies }) {
      state.authToken = token;
      state.refreshToken = refreshToken || null;
      state.currentUser = user;
      state.companies = companies || [];
      state.currentCompany = null;
      localStorage.setItem("authToken", token);
      if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("currentUser", JSON.stringify(user));
      localStorage.setItem("companies", JSON.stringify(companies || []));
      localStorage.removeItem("currentCompany");
      resetTheme();
    },
    SET_TOKEN(state, token) {
      state.authToken = token;
      localStorage.setItem("authToken", token);
    },
    SET_COMPANY(state, company) {
      state.currentCompany = company;
      localStorage.setItem("currentCompany", JSON.stringify(company));
      applyTheme(company);
    },
    CLEAR_COMPANY(state) {
      state.currentCompany = null;
      localStorage.removeItem("currentCompany");
      resetTheme();
    },
    ADD_COMPANY(state, company) {
      state.companies.push(company);
      localStorage.setItem("companies", JSON.stringify(state.companies));
    },
    UPDATE_COMPANY(state, company) {
      const idx = state.companies.findIndex((c) => c.id === company.id);
      if (idx !== -1) state.companies.splice(idx, 1, company);
      localStorage.setItem("companies", JSON.stringify(state.companies));
      if (state.currentCompany?.id === company.id) {
        state.currentCompany = { ...state.currentCompany, ...company };
        localStorage.setItem(
          "currentCompany",
          JSON.stringify(state.currentCompany)
        );
      }
    },
    CLEAR_AUTH(state) {
      state.authToken = null;
      state.refreshToken = null;
      state.currentUser = null;
      state.currentCompany = null;
      state.companies = [];
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("currentUser");
      localStorage.removeItem("currentCompany");
      localStorage.removeItem("companies");
      resetTheme();
    },
  },
  actions: {},
  modules: {},
});
